import { UserRole } from '@symfa-inc/providence-types';

export const isNotOnlyReadOnlyUser = (roles: UserRole[] = []): boolean =>
  !(roles.length === 1 && roles.includes(UserRole.ReadOnly));
